import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ColumnsProvider from '../../../utils/ColumnsProvider'
import InventoryForm from '../../../components/forms/InventoryForm'
import Popup from '../../../components/elements/Popup'
import Confirm from '../../../components/elements/Confirm'
import Details from '../../../components/elements/Details'
import Table from '../../../components/elements/Table'
import Dismissible from '../../../components/elements/Dismissible'
import Form from '../../../components/elements/Form'
import LocationSelect from '../../../components/elements/forms/LocationSelect'

import Types from '../../../actions/Types'
import PostPhase1Action from '../../../actions/inventories/PostPhase1Action'
import PrintAction from '../../../actions/print/PrintInventoryToFillAction'
import PostPhase2Action from '../../../actions/inventories/PostPhase2Action'
import DeleteAction from '../../../actions/inventories/DeleteAction'
import ListLocationsAction from '../../../actions/locations/ListLinearAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class CreateInventoryPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      phase: 1,
      submit1: null,
      print1: null,
      data2: null,
      isCancelling2: false,
      selected2: null,
      error: null
    }

    // Bind events
    this.submit1 = this.submit1.bind(this)
    this.print1 = this.print1.bind(this)
    this.submit2 = this.submit2.bind(this)
    this.cancel2 = this.cancel2.bind(this)
    this.cancel2Confirm = this.cancel2Confirm.bind(this)
    this.onSelectLocation = this.onSelectLocation.bind(this)
    this.onChangeFound = this.onChangeFound.bind(this)
    this.onSubmit1 = this.onSubmit1.bind(this)
    this.onPrint1 = this.onPrint1.bind(this)
  }

  componentDidMount() {
    this.props.fetchLocations()
  }

  componentDidUpdate(prevProps, prevState) {
    // On phase 1 success, go to phase 2
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.saveError
      &&
      this.props.phase === 1
    ) {
      this.setState({
        phase: 2,
        selected2: this.getLocationCompartmentKey(_.first(this.props.data2.locations)),
        data2: _.extend(
          {},
          this.props.data2,
          {
            locations: _.map(
              this.props.data2.locations,
              (location) => (_.extend(
                {},
                location,
                {
                  categories: _.map(
                    location.categories,
                    (category) => (_.extend(
                      {},
                      category,
                      {
                        items: _.map(
                          category.items,
                          (item) => _.extend(
                            {},
                            item,
                            {
                              found: ''
                            }
                          )
                        )
                      }
                    ))
                  )
                }
              ))
            )
          }
        )
      })
    }

    // On phase 2 success, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.saveError
      &&
      this.props.phase === 2
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Inventaire exécuté avec succès.')
      this.props.onClose(this.state.data2.id)
    }

    // On phase 2 cancellation, close popup
    if (
      prevProps.isDeleting
      &&
      !this.props.isDeleting
    ) {
      AppUtils.setStatus(
        this.props.deleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.WARNING,
        this.props.deleteError
          ? AppUtils.errorToText(this.props.deleteError)
          : 'Inventaire annulé.'
      )
      this.props.onClose(null)
    }
  }

  submit1() {
    if (_.isFunction(this.state.submit1)) {
      this.state.submit1()
    }
  }

  print1() {
    if (_.isFunction(this.state.print1)) {
      this.state.print1()
    }
  }

  submit2() {
    // Check that everything has been filled
    const wipCount = _.reduce(
      _.flatten(
        _.map(
          this.state.data2.locations,
          (location) => (
            _.map(
              location.categories,
              (category) => (
                _.size(
                  _.filter(
                    category.items,
                    (item) => (_.isString(item.found))
                  )
                )
              )
            )
          )
        )
      ),
      (acc, count) => (acc + count),
      0
    )
    if (wipCount > 0) {
      this.setState({
        error: `La saisie n'est pas terminée pour ${wipCount} pièces.`
      })
    }
    else {
      this.setState({
        error: null
      })
      this.props.postPhase2(this.state.data2)
    }
  }

  cancel2() {
    this.setState({
      isCancelling2: true
    })
  }

  cancel2Confirm(proceed) {
    this.setState({
      isCancelling2: false
    })
    if (proceed) {
      this.props.delete(this.state.data2.id)
    }
  }

  onSelectLocation(selected2) {
    this.setState({ selected2 })
  }

  onChangeFound(locationId, compartment, categoryId, itemIdx) {
    return (found) => {
      this.setState((prevState, props) => ({
        data2: _.extend(
          {},
          prevState.data2,
          {
            locations: _.map(
              prevState.data2.locations,
              (location) => (location.location.id === locationId && location.compartment === compartment
                ? _.extend(
                    {},
                    location,
                    {
                      categories: _.map(
                        location.categories,
                        (category) => (category.category.id === categoryId
                          ? _.extend(
                              {},
                              category,
                              {
                                items: _.map(
                                  category.items,
                                  (item, idx) => (idx === itemIdx
                                    ? _.extend(
                                        {},
                                        item,
                                        {
                                          found
                                        }
                                      )
                                    : item
                                  )
                                )
                              }
                            )
                          : category
                        )
                      )
                    }
                  )
                : location
              )
            )
          }
        )
      }))
    }
  }

  onSubmit1(data) {
    this.props.postPhase1(data)
  }

  onPrint1(query) {
    this.props.print(query)
  }

  getLocationCompartmentKey(location) {
    return `${location.location.id}_/_${location.compartment}`
  }

  render() {
    const locationsList = this.state.phase === 2
      ? (
          _.map(
            this.state.data2.locations,
            (location) => {
              const items = _.flatten(
                _.map(
                  location.categories,
                  (category) => (category.items)
                )
              )
              const successCount = _.reduce(
                items,
                (count, item) => (count + (_.isString(item.found) ? 0 : item.found)),
                0
              )
              const missingCount = _.reduce(
                items,
                (count, item) => (count + (_.isString(item.found) ? 0 : (item.expected - item.found))),
                0
              )
              const wipCount = _.size(
                _.filter(
                  items,
                  (item) => (_.isString(item.found))
                )
              )
              return {
                id: this.getLocationCompartmentKey(location),
                stickers: [
                  ...(location.location.stickers),
                  ...(
                    location.compartment.length > 0
                      ? [{
                          name: location.compartment,
                          color: {
                            background: 'E0E0E0',
                            foreground: '666666'
                          },
                          noBorder: true
                        }]
                      : []
                  )
                ],
                details: _.union(
                  successCount > 0
                    ? [{
                        icon: Details.ICON.SUCCESS,
                        text: `${successCount} pièce${successCount > 1 ? 's' : ''} trouvée${successCount > 1 ? 's' : ''}`
                      }]
                    : [],
                  missingCount > 0
                    ? [{
                        icon: Details.ICON.FAILURE,
                        text: `${missingCount} pièce${missingCount > 1 ? 's' : ''} manquante${missingCount > 1 ? 's' : ''}`
                      }]
                    : [],
                  wipCount > 0
                    ? [{
                        icon: Details.ICON.WARNING,
                        text: "Saisie non terminée"
                      }]
                    : []
                )
              }
            }
          )
        )
      : null
    const selectedLocation = this.state.phase === 2 && this.state.selected2
      ? _.find(
          this.state.data2.locations,
          (location) => {
            const keyParts = this.state.selected2.split('_/_');
            return location.location.id === parseInt(keyParts[0], 10) && location.compartment === keyParts[1];
          }
        )
      : null
    const productsList = !_.isNull(selectedLocation)
      ? (
          _.flatten(
            _.map(
              selectedLocation.categories,
              (category) => (_.union(
                [
                  Table.headerRow(
                    category.category.name,
                    category.category.color.foreground,
                    category.category.color.background
                  )
                ],
                _.map(
                  category.items,
                  (item, index) => (
                    _.extend(
                      {},
                      _.pick(item, 'product', 'expected', 'found'),
                      _.pick(item.item, 'compartment'),
                      {
                        number: !_.isNull(item.product.prefix)
                          ? `${item.product.prefix}${item.item.number}`
                          : null
                      },
                      {
                        location: selectedLocation.location.id,
                        category: category.category.id,
                        index
                      }
                    )
                  )
                )
              ))
            )
          )
        )
      : null
    return (
      this.state.phase === 1
        ? <Popup
            header="Effectuer un inventaire (base)"
            body={
              <InventoryForm
                data={undefined}
                location={this.props.location}
                onSubmit={this.onSubmit1}
                onPrint={this.onPrint1}
                onClearError={this.props.clearError}
                isLoading={false}
                isSaving={this.props.isSaving}
                registerSubmit={(submit1) => { this.setState({ submit1 })}}
                registerPrint={(print1) => { this.setState({ print1 }) }}
                error={this.props.saveError}
                locationsList={this.props.locationsList}
                locationsIsFetching={this.props.locationsIsFetching}
              />
            }
            footer={[
              {
                type: Popup.BUTTONTYPE.CLOSE,
                title: 'Annuler',
                color: 'red',
                icon: 'close',
                basic: true,
                onClick: () => this.props.onClose(null)
              },
              {
                type: Popup.BUTTONTYPE.GENERIC,
                title: 'Imprimer',
                color: 'blue',
                icon: 'print',
                onClick: this.print1
              },
              {
                type: Popup.BUTTONTYPE.SUBMIT,
                title: 'Démarrer',
                color: 'green',
                icon: 'play',
                onClick: this.submit1
              }
            ]}
            isLoading={false}
            isSaving={this.props.isSaving}
          />
        : <React.Fragment>
            <Popup
              header="Effectuer un inventaire (détails)"
              body={
                <React.Fragment>
                  {
                    this.props.saveError
                      ? <Dismissible
                          header={AppUtils.errorToTitle(this.props.saveError)}
                          content={AppUtils.errorToText(this.props.saveError)}
                          color='red'
                          onDismiss={this.props.clearError}
                        />
                      : null
                  }
                  {
                    !_.isNull(this.state.error)
                      ? <Dismissible
                          content={this.state.error}
                          color='orange'
                          onDismiss={() => { this.setState({ error: null }) }}
                        />
                      : null
                  }
                  <div style={{
                    height: '70vh',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <div style={{
                      flex: '0 0 auto'
                    }}>
                      <Form
                        onSubmit={() => {}}
                        loading={this.props.isSaving}
                      >
                        <LocationSelect
                          label='Emplacement'
                          loading={false}
                          options={locationsList}
                          selected={this.state.selected2}
                          onChange={this.onSelectLocation}
                        />
                      </Form>
                    </div>
                    <Table
                      columns={[
                        // Matériel
                        ColumnsProvider.itemProduct,
                        // N°
                        ColumnsProvider.itemNumberFull,
                        // Compartiment
                        ColumnsProvider.itemCompartmentBasic,
                        // Supposé
                        ColumnsProvider.inventoryItemFillExpected,
                        // Trouvé
                        ColumnsProvider.inventoryItemFillFound(this.onChangeFound),
                        // Status
                        ColumnsProvider.inventoryItemFillStatus
                      ]}
                      data={productsList}
                      error={null}
                      isLoading={false}
                      emptyMessage="Aucun matériel dans cet emplacement."
                    />
                  </div>
                </React.Fragment>
              }
              footer={[
                {
                  type: Popup.BUTTONTYPE.CLOSE,
                  title: 'Arrêter',
                  color: 'red',
                  icon: 'close',
                  basic: true,
                  onClick: this.cancel2
                },
                {
                  type: Popup.BUTTONTYPE.SUBMIT,
                  title: 'Terminer',
                  color: 'green',
                  icon: 'checkmark',
                  onClick: this.submit2
                }
              ]}
              size='fullscreen'
              isLoading={false}
              isSaving={this.props.isSaving || this.props.isDeleting}
            />
            {
              this.state.isCancelling2
                ? <Confirm
                    header="Arrêt de l'inventaire"
                    body="Êtes-vous sûr de vouloir arrêter l'inventaire en cours ? Toutes les informations saisies seront perdues."
                    confirmText="Arrêter"
                    confirmColor='red'
                    confirmIcon='trash'
                    callback={this.cancel2Confirm}
                  />
                : null
            }
          </React.Fragment>
    )
  }
}

CreateInventoryPopup.propTypes = {
  // Properties
  location: PropTypes.number,
  onClose: PropTypes.func.isRequired,

  // Redux State
  phase: PropTypes.number,
  isSaving: PropTypes.bool.isRequired,
  saveError: PropTypes.object,
  data2: PropTypes.object,
  isDeleting: PropTypes.bool.isRequired,
  deleteError: PropTypes.object,
  locationsList: PropTypes.array,
  locationsIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  postPhase1: PropTypes.func.isRequired,
  print: PropTypes.func.isRequired,
  postPhase2: PropTypes.func.isRequired,
  delete: PropTypes.func.isRequired,
  fetchLocations: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    phase: state.entities.inventories.post.phase,
    isSaving: state.entities.inventories.post.isFetching,
    saveError: state.entities.inventories.post.error,
    data2: state.entities.inventories.post.data,
    isDeleting: state.entities.inventories.delete.isFetching,
    deleteError: state.entities.inventories.delete.error,
    locationsList: state.entities.locations.list.linear.data,
    locationsIsFetching: state.entities.locations.list.linear.isFetching
  }),
  (dispatch) => ({
    postPhase1: (data) => (dispatch(PostPhase1Action({ data }))),
    print: ({ location: { id }, ...query }) => (dispatch(PrintAction({ id, query }))),
    postPhase2: (data) => (dispatch(PostPhase2Action({ data }))),
    delete: (id) => (dispatch(DeleteAction({ id }))),
    fetchLocations: () => (dispatch(ListLocationsAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.INVENTORIES.POST)))
  })
)(CreateInventoryPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/inventories/CreateInventoryPopup.js